import { render, staticRenderFns } from "./DpiTable.vue?vue&type=template&id=b74851a4&"
import script from "./DpiTable.vue?vue&type=script&lang=js&"
export * from "./DpiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports